import { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { map, noop, includes } from 'lodash-es'
import NotificationListItem from './notification_list_item'
import HiddenInput from '../forms/hidden_input'
import AuthenticityToken from '../forms/authenticity_token'

export default class NotificationsList extends Component {
  constructor(props) {
    super(props)
    this.$formRef = createRef()
  }

  handleNotificationSelection = (notification, selected) => {
    const { onSelectNotification } = this.props
    onSelectNotification(notification, selected)
  }

  getHiddenField() {
    const { formMethod } = this.props
    const method = formMethod.toLowerCase()
    if (method === 'delete' || method === 'put') {
      return <HiddenInput name="_method" value={method} />
    }
    return null
  }

  getRows() {
    const { notifications, selectedNotifications } = this.props
    return map(notifications, notification => {
      const isChecked = includes(selectedNotifications, notification)
      return (
        <NotificationListItem
          notification={notification}
          checked={isChecked}
          onSelect={this.handleNotificationSelection}
          key={notification.id}
          readOnly
        />
      )
    })
  }

  // public method to submit the form
  submit() {
    return this.$formRef.current.submit()
  }

  render() {
    const { notifications } = this.props
    if (notifications.length === 0) {
      return <div>You don&apos;t have any notifications.</div>
    } else {
      const { formAction } = this.props
      const rows = this.getRows()
      const hiddenField = this.getHiddenField()
      return (
        <form className="notifications-form" action={formAction} method="post" ref={this.$formRef}>
          {hiddenField}
          <AuthenticityToken />
          <ul className="unstyled-list notifications-list">{rows}</ul>
        </form>
      )
    }
  }
}
NotificationsList.propTypes = {
  formAction: PropTypes.string.isRequired,
  formMethod: PropTypes.string.isRequired,
  notifications: PropTypes.array.isRequired,
  selectedNotifications: PropTypes.array.isRequired,
  onSelectNotification: PropTypes.func,
}
NotificationsList.defaultProps = {
  onSelectNotification: noop,
}
